import Image from 'next/image';
import classnames from 'classnames';

import Logos from '@/svg/logos.svg';

export function DefaultLogoReel({ showPretext = true, className }) {
  return (
    <div
      className={classnames('max-w-full mx-auto px-6 text-center', className)}
    >
      {showPretext && (
        <p className="text-haiti text-lg font-semibold mb-8">
          Trusted by teams of all sizes to deliver content to millions across
          the world
        </p>
      )}
      <Logos className="block mx-auto max-w-full" />
    </div>
  );
}

export function CustomLogoReel({ title, theme, logos }, className) {
  const wrapperClass = classnames(
    'max-w-full mx-auto px-6 py-16 text-center',
    {
      'bg-haiti': theme === 'dark',
      'bg-transparent': theme === 'light',
    },
    className,
  );

  const textClass = classnames(
    'text-xs uppercase tracking-wide font-semibold mb-8',
    {
      'text-rose': theme === 'dark',
      'text-cornflower': theme === 'light',
    },
  );

  return (
    <div className={wrapperClass}>
      <p className={textClass}>{title}</p>
      <div className="flex flex-row flex-wrap items-center justify-center mx-auto max-w-4xl lg:max-w-6xl">
        {logos.map((logo) => (
          <Image
            key={logo.id}
            className="mx-4 flex-wrap max-h-[77px]"
            src={logo.url}
            width={logo.width}
            height={logo.height}
            alt={`${title} logo`}
          />
        ))}
      </div>
    </div>
  );
}
